const TOKEN_KEY = 'amaze_token';
const PROFILE_KEY = 'amaze_profile';
function createAuthStore() {
    let listeners = [];
    let state = {
        token: localStorage.getItem(TOKEN_KEY),
        profile: (() => {
            try {
                const raw = localStorage.getItem(PROFILE_KEY);
                return raw ? JSON.parse(raw) : null;
            }
            catch {
                return null;
            }
        })(),
    };
    function notify() {
        listeners.forEach((fn) => fn(state));
    }
    return {
        getState: () => state,
        getToken: () => state.token,
        getProfile: () => state.profile,
        isAuthenticated: () => !!state.token && !!state.profile,
        canAdmin: () => state.profile?.role === 'vice_president' ||
            state.profile?.role === 'president',
        isPresident: () => state.profile?.role === 'president',
        setAuth: (token, profile) => {
            state = { token, profile };
            localStorage.setItem(TOKEN_KEY, token);
            localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
            notify();
        },
        logout: () => {
            state = { token: null, profile: null };
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(PROFILE_KEY);
            notify();
        },
        subscribe: (listener) => {
            listeners.push(listener);
            return () => {
                listeners = listeners.filter((l) => l !== listener);
            };
        },
    };
}
export const authStore = createAuthStore();
